/* Stressless Store — configurator Stressless Adam (elektrisch, Disc / Sirius).
   Data + stijl: window.CFGRELAX.adam (cfg-adam-data.js). Afgeleid van cfg-relax.js v4.
   Render-PID: Disc 1729710 + stof(3) + kleur(2) + hout(2) + hout(2); Sirius 1729711 + stof + kleur + hout(2) + alu(2). */
(function () {
  var sec = document.querySelector('#configurator[data-model="adam"]');
  if (!sec) return;
  var PACK = (window.CFGRELAX || {}).adam;
  if (!PACK || !PACK.D) return;
  var D = PACK.D, CDN = D.CDN, NAAM = D.MODEL;

  var COLS = D.COVERS.map(function (s) {
    var p = s.split('|');
    return { code: p[0], name: p[1], type: p[2], groep: p[3],
      colors: p[4].split(',').map(function (c) { var q = c.split(':'); return { c: q[0], n: q[1] }; }) };
  });
  var COLBY = {}; COLS.forEach(function (c) { COLBY[c.code] = c; });
  var GRPLAB = {}; D.GROUPS.forEach(function (g) { GRPLAB[g[0]] = g[1]; });
  var BASE = {}; D.BASES.forEach(function (b) { BASE[b.k] = b; });

  var S = { base: 'dis', coll: '094', kleur: '40', hout: '33', alu: '46', frame: 'front', mat: 'leder', batt: false };
  if (D.START) for (var k in D.START) S[k] = D.START[k];
  var touched = false;

  function missing(base, coll, kleur) { return (D.MISSING || []).indexOf(base + '-' + coll + kleur) >= 0; }
  function readHash() {
    var m = (location.hash || '').match(/cfg=([a-z0-9\-]+)/i); if (!m) return;
    var p = m[1].split('-');
    if (BASE[p[0]]) S.base = p[0];
    if (p[1] && COLBY[p[1].slice(0, 3)]) { S.coll = p[1].slice(0, 3); S.kleur = p[1].slice(3); }
    if (p[2]) S.hout = p[2];
    if (p[3]) S.alu = p[3];
    if (p[4]) S.batt = p[4] === 'b1';
    normalise();
  }
  function hashVal() { return [S.base, S.coll + S.kleur, S.hout, S.alu, S.batt ? 'b1' : 'b0'].join('-'); }
  function writeHash() {
    if (!touched) return;
    try { history.replaceState(null, '', location.pathname + location.search + '#cfg=' + hashVal()); } catch (e) { }
  }
  function normalise() {
    var col = COLBY[S.coll];
    if (!col.colors.some(function (c) { return c.c === S.kleur; })) S.kleur = col.colors[0].c;
    if (missing(S.base, S.coll, S.kleur)) {
      var ok = col.colors.filter(function (c) { return !missing(S.base, S.coll, c.c); })[0];
      if (ok) S.kleur = ok.c;
    }
    if (!D.WOOD.some(function (w) { return w[0] === S.hout; })) S.hout = D.WOOD[0][0];
    if (!D.ALU.some(function (a) { return a[0] === S.alu; })) S.alu = D.ALU[0][0];
    S.mat = col.type;
  }
  function wname() { return (D.WOOD.filter(function (w) { return w[0] === S.hout; })[0] || [])[1] || ''; }
  function aname() { return (D.ALU.filter(function (a) { return a[0] === S.alu; })[0] || [])[1] || ''; }
  function kname() { var col = COLBY[S.coll]; return (col.colors.filter(function (c) { return c.c === S.kleur; })[0] || {}).n || ''; }
  function excl() { return (D.EXCL || []).indexOf(S.hout) >= 0; }

  function pid(baseKey) {
    var b = BASE[baseKey || S.base];
    return b.art + S.coll + S.kleur + S.hout + (b.alu ? S.alu : S.hout);
  }
  function shot(size, frame, o) {
    o = o || {};
    return CDN + pid(o.base) + '_' + size + '_' + (frame || 'front') + '.jpg';
  }
  var FRAMES = ['front', '01', '02', '03'];
  function setShot(el, url) {
    var img = el.querySelector('img');
    if (img.getAttribute('src') !== url) {
      var pre = new Image();
      el.classList.add('busy');
      pre.onload = function () { img.src = url; el.classList.remove('busy'); };
      pre.onerror = function () { img.src = url; el.classList.remove('busy'); };
      pre.src = url;
    }
  }

  function grp() { return COLBY[S.coll].groep; }
  function prijs() { var r = D.P[S.base]; return r ? (r[grp()] || null) : null; }
  function eur(n) { return '€ ' + Number(n).toLocaleString('nl-BE'); }
  function vanafGroep(g) { var r = D.P[S.base]; return r && r[g] ? r[g][0] : null; }

  var el = {};

  function media() {
    setShot(el.stage, shot('515x515', S.frame));
    el.stage.querySelector('img').alt = 'Stressless ' + NAAM + ' ' + samenvatting();
    var t = '';
    FRAMES.forEach(function (f) {
      t += '<button class="c3-th' + (f === S.frame ? ' on' : '') + '" data-frame="' + f + '" aria-label="Aanzicht">' +
        '<span class="c3-shot"><span class="c3-in"><img loading="lazy" alt=""></span></span></button>';
    });
    el.thumbs.innerHTML = t;
    el.thumbs.querySelectorAll('[data-frame]').forEach(function (b) {
      var f = b.getAttribute('data-frame');
      setShot(b.querySelector('.c3-shot'), shot('300x300', f));
      b.onclick = function () { S.frame = f; media(); };
    });
  }

  function panel() {
    var b = BASE[S.base], col = COLBY[S.coll], out = '';

    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">1</span> Onderstel<em>' + b.label + '</em></div><div class="c3-opts c3-bases">';
    D.BASES.forEach(function (o) {
      out += '<button class="c3-card' + (o.k === S.base ? ' on' : '') + '" data-base="' + o.k + '">' +
        '<span class="c3-shot"><span class="c3-in"><img loading="lazy" alt="' + NAAM + ' ' + o.label + '" src="' +
        CDN + o.art + S.coll + S.kleur + S.hout + (o.alu ? S.alu : S.hout) + '_300x300_front.jpg"></span></span>' +
        '<b>' + o.label + '</b></button>';
    });
    out += '</div><p class="c3-note">' + b.note + '</p>';
    var d = D.DIM;
    out += '<p class="c3-note">Eén universele maat · breedte ' + d[0] + ' cm · diepte ' + d[1] + ' cm · hoogte ' + d[2] +
      ' cm · zithoogte ' + d[3] + ' cm · zitdiepte ' + d[4] + ' cm</p></div>';

    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">2</span> Stroom<em>' + (S.batt ? 'Met batterij' : 'Met snoer') + '</em></div>' +
      '<div class="c3-opts"><button class="c3-chip' + (!S.batt ? ' on' : '') + '" data-batt="0"><span>Met snoer naar het stopcontact</span></button>' +
      '<button class="c3-chip' + (S.batt ? ' on' : '') + '" data-batt="1"><span>Met oplaadbare batterij <i>+ ' + eur(D.BATT.prijs) + '</i></span></button></div>' +
      '<p class="c3-note">De Adam is standaard volledig elektrisch met voetensteun in de zetel. Met de batterij zet je hem vrij in de kamer, zonder kabel over de vloer.</p></div>';

    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">3</span> Bekleding &amp; kleur<em>' + col.name + ' ' + kname() + '</em></div>';
    out += '<div class="c3-tabs">' +
      '<button class="c3-tab' + (S.mat === 'leder' ? ' on' : '') + '" data-mat="leder"><img src="' + CDN + 'leather.svg" alt="">Leder</button>' +
      '<button class="c3-tab' + (S.mat === 'stof' ? ' on' : '') + '" data-mat="stof"><img src="' + CDN + 'fabric.svg" alt="">Stof</button></div>';
    out += '<div class="c3-colls">';
    COLS.filter(function (c) { return c.type === S.mat; }).forEach(function (c) {
      var v = vanafGroep(c.groep);
      out += '<button class="c3-pill' + (c.code === S.coll ? ' on' : '') + '" data-coll="' + c.code + '">' +
        '<b>' + c.name + '</b><span>' + (v ? 'vanaf ' + eur(v) : 'op aanvraag') + '</span></button>';
    });
    out += '</div><div class="c3-sw">';
    col.colors.forEach(function (c) {
      var mi = missing(S.base, col.code, c.c);
      out += '<button class="c3-swb' + (c.c === S.kleur ? ' on' : '') + (mi ? ' dis' : '') + '"' + (mi ? ' disabled' : ' data-kleur="' + c.c + '"') +
        ' title="' + col.name + ' ' + c.n + (mi ? ' — niet met ' + b.label : '') + '">' +
        '<img loading="lazy" src="' + CDN + col.code + '_' + c.c + '_50.jpg" alt="' + col.name + ' ' + c.n + '"></button>';
    });
    out += '</div>';
    out += '<div class="c3-sel" id="c3sel"><img src="' + CDN + col.code + '_' + S.kleur + '_200.jpg" alt="">' +
      '<div><b>' + col.name + ' ' + kname() + '</b><span>' + GRPLAB[col.groep] + ' · klik voor een grote weergave</span></div></div>';
    out += '</div>';

    out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">4</span> Hout' + (b.alu ? ' (armpanelen)' : ' (armpanelen en voet)') + '<em>' + wname() + '</em></div>';
    out += '<p class="c3-sub">Standaard — gelaagd beuken</p><div class="c3-sw c3-wood">';
    D.WOOD.forEach(function (w) {
      if ((D.EXCL || []).indexOf(w[0]) >= 0) return;
      out += '<button class="c3-swb' + (w[0] === S.hout ? ' on' : '') + '" data-hout="' + w[0] + '" title="' + w[1] + '">' +
        '<img loading="lazy" src="' + CDN + 'C_PC3_ACOLOR_' + w[0] + '_50.jpg" alt="' + w[1] + '"></button>';
    });
    out += '</div><p class="c3-sub">Exclusive Wood — massief eik</p><div class="c3-sw c3-wood">';
    D.WOOD.forEach(function (w) {
      if ((D.EXCL || []).indexOf(w[0]) < 0) return;
      out += '<button class="c3-swb' + (w[0] === S.hout ? ' on' : '') + '" data-hout="' + w[0] + '" title="' + w[1] + '">' +
        '<img loading="lazy" src="' + CDN + 'C_PC3_ACOLOR_' + w[0] + '_50.jpg" alt="' + w[1] + '"></button>';
    });
    out += '</div><p class="c3-note">' + (b.alu ? 'De houten panelen omarmen de kuip aan beide zijden.' : 'Bij Disc hebben de armpanelen en de ronde voet dezelfde houtkleur.') + '</p></div>';

    if (b.alu) {
      out += '<div class="c3-step"><div class="c3-lab"><span class="c3-no">5</span> Afwerking Sirius-voet<em>' + aname() + '</em></div><div class="c3-opts">';
      D.ALU.forEach(function (a) {
        out += '<button class="c3-chip' + (a[0] === S.alu ? ' on' : '') + '" data-alu="' + a[0] + '">' +
          '<img src="' + CDN + 'C_PC3_BCOLOR_' + a[0] + '_50.jpg" alt=""><span>' + a[1] + '</span></button>';
      });
      out += '</div></div>';
    }

    el.panel.innerHTML = out;
    bindPanel();
    priceBlocks();
  }

  function samenvatting() {
    var b = BASE[S.base], col = COLBY[S.coll];
    var l = [NAAM + ' ' + b.label, col.name + ' ' + kname(), 'hout ' + wname()];
    if (b.alu) l.push('voet ' + aname());
    l.push(S.batt ? 'met batterij' : 'met snoer');
    return l.join(' · ');
  }

  function priceHTML(compact) {
    var pr = prijs();
    if (!pr) return '<div class="c3-price"><span class="c3-now">Prijs op aanvraag</span></div>';
    return '<div class="c3-price"><span class="c3-now">' + eur(pr[0]) + '</span>' +
      '<span class="c3-was">' + eur(pr[1]) + '</span><span class="c3-badge">−10%</span>' +
      (compact ? '' : '<p class="c3-fine">Actieprijs Stressless Store · je bespaart ' + eur(pr[1] - pr[0]) +
        ' · incl. btw · gratis levering in België en Nederland · levertijd ± 8 weken</p>') +
      (S.batt && !compact ? '<p class="c3-fine">+ ' + eur(D.BATT.prijs) + ' oplaadbare batterij — samen <b>' + eur(pr[0] + D.BATT.prijs) + '</b></p>' : '') + '</div>';
  }

  function priceBlocks() {
    el.buy.innerHTML = priceHTML(false) +
      '<div class="c3-sum">' + samenvatting() + '</div>' +
      '<div class="c3-actions"><button class="sp-btn sp-btn-dark" id="c3add">In winkelmand</button>' +
      '<a class="sp-btn sp-btn-outline" href="#showroom">Liever eerst proefzitten</a></div>' +
      '<div class="c3-msg" id="c3msg"></div>';
    el.bar.innerHTML = '<div class="c3-barin"><div class="c3-barp">' + priceHTML(true) +
      '<span class="c3-barsum">' + samenvatting() + '</span></div>' +
      '<button class="sp-btn sp-btn-dark" id="c3add2">In winkelmand</button></div>';
    var f = function () { addToCart(); };
    var a = document.getElementById('c3add'); if (a) a.onclick = f;
    var a2 = document.getElementById('c3add2'); if (a2) a2.onclick = f;
  }

  function bindPanel() {
    var p = el.panel;
    p.querySelectorAll('[data-base]').forEach(function (b) { b.onclick = function () { S.base = b.getAttribute('data-base'); upd(true); }; });
    p.querySelectorAll('[data-batt]').forEach(function (b) { b.onclick = function () { S.batt = b.getAttribute('data-batt') === '1'; upd(true); }; });
    p.querySelectorAll('[data-mat]').forEach(function (b) {
      b.onclick = function () {
        S.mat = b.getAttribute('data-mat');
        var first = COLS.filter(function (c) { return c.type === S.mat; })[0];
        S.coll = first.code; S.kleur = first.colors[0].c; upd(true);
      };
    });
    p.querySelectorAll('[data-coll]').forEach(function (b) {
      b.onclick = function () { S.coll = b.getAttribute('data-coll'); S.kleur = COLBY[S.coll].colors[0].c; upd(true); };
    });
    p.querySelectorAll('[data-kleur]').forEach(function (b) { b.onclick = function () { S.kleur = b.getAttribute('data-kleur'); upd(true); }; });
    p.querySelectorAll('[data-hout]').forEach(function (b) { b.onclick = function () { S.hout = b.getAttribute('data-hout'); upd(true); }; });
    p.querySelectorAll('[data-alu]').forEach(function (b) { b.onclick = function () { S.alu = b.getAttribute('data-alu'); upd(true); }; });
    var sel = document.getElementById('c3sel');
    if (sel) sel.onclick = function () {
      var col = COLBY[S.coll];
      openLB(CDN + col.code + '_' + S.kleur + '_200.jpg', col.name + ' ' + kname(), true);
    };
  }

  function openLB(src, cap, small) {
    el.lb.querySelector('.c3-lbimg').innerHTML = '<img src="' + src + '" alt=""' + (small ? ' style="max-width:420px"' : '') + '>';
    el.lb.querySelector('.c3-lbcap').textContent = cap;
    el.lb.classList.add('on');
  }

  function post(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); location.href = '/cart'; });
  }

  function addToCart() {
    var b = BASE[S.base], col = COLBY[S.coll], pr = prijs();
    var msg = document.getElementById('c3msg');
    var o1 = b.label, o2 = GRPLAB[col.groep];
    var props = { 'Maat': 'Universele maat', 'Kleur': col.name + ' ' + kname(),
      'Houtkleur': wname() + (excl() ? ' (Exclusive Wood, massief eik)' : '') };
    if (b.alu) props['Afwerking Sirius-voet'] = aname();
    props['Stroom'] = S.batt ? 'Met oplaadbare batterij (apart op de bestelling)' : 'Met snoer';
    props['Let op'] = D.NOTE;
    props['_foto'] = shot('515x515', 'front');
    props['_crop'] = '';
    props['_link'] = location.origin + location.pathname + '#cfg=' + hashVal();

    if (location.hostname.indexOf('stresslessstore') < 0) {
      if (msg) { msg.className = 'c3-msg on'; msg.innerHTML = '<b>Preview</b> — dit komt in de winkelmand:<br>' + samenvatting() + '<br>' + (pr ? eur(pr[0]) : '') + ' · variant <code>' + o1 + ' / ' + o2 + '</code>'; }
      return;
    }
    var btns = [document.getElementById('c3add'), document.getElementById('c3add2')].filter(Boolean);
    btns.forEach(function (x) { x.disabled = true; x.textContent = 'Bezig…'; });
    fetch('/products/' + D.HANDLE + '.js').then(function (r) { return r.json(); }).then(function (pd) {
      var v = pd.variants.filter(function (x) { return x.option1 === o1 && x.option2 === o2; })[0];
      if (!v) throw new Error('variant');
      var items = [{ id: v.id, quantity: 1, properties: props }];
      if (!S.batt) return post(items);
      return fetch('/products/' + D.BATT.handle + '.js').then(function (r) { return r.json(); }).then(function (bp) {
        items.push({ id: bp.variants[0].id, quantity: 1, properties: { 'Hoort bij': 'Stressless® ' + NAAM + ' ' + o1 + ' (' + o2 + ')' } });
        return post(items);
      });
    }).catch(function () {
      btns.forEach(function (x) { x.disabled = false; x.textContent = 'In winkelmand'; });
      if (msg) { msg.className = 'c3-msg on'; msg.innerHTML = 'Deze samenstelling kunnen we niet online afronden. <a href="#adam-contact">Stuur ons je keuze door</a> of bel de winkel — we regelen het meteen voor je.'; }
    });
  }

  function upd(fromUser) {
    if (fromUser) touched = true;
    normalise(); panel(); media(); writeHash();
  }

  function init() {
    if (!document.getElementById('c3css')) {
      var st = document.createElement('style');
      st.id = 'c3css'; st.textContent = PACK.CSS || '';
      document.head.appendChild(st);
    }
    var wrap = sec.querySelector('.wrap') || sec;
    var root = document.createElement('div'); root.id = 'cfg3'; wrap.appendChild(root);
    var tr = document.createElement('div'); tr.className = 'c3-trust';
    tr.innerHTML = '<span>Gratis levering in België én Nederland</span><span>Levertijd ± 8 weken · op maat gemaakt in Noorwegen</span>' +
      '<span>Beste prijsgarantie — vind je exact hetzelfde elders goedkoper, dan verlagen wij onze prijs</span>';
    wrap.appendChild(tr);
    root.innerHTML =
      '<div class="c3-grid">' +
      '<div class="c3-media"><div class="c3-stage c3-shot" id="c3stage"><span class="c3-in"><img alt="Stressless ' + NAAM + '"></span>' +
      '<button class="c3-zoom" id="c3zoom" aria-label="Vergroot">⤢</button></div>' +
      '<div class="c3-thumbs" id="c3thumbs"></div></div>' +
      '<div class="c3-right"><div class="c3-panel" id="c3panel"></div><div class="c3-buy" id="c3buy"></div></div>' +
      '</div><div class="c3-bar" id="c3bar"></div>' +
      '<div class="c3-lb" id="c3lb"><div class="c3-lbimg"></div><p class="c3-lbcap"></p></div>';
    el.stage = document.getElementById('c3stage');
    el.thumbs = document.getElementById('c3thumbs');
    el.panel = document.getElementById('c3panel');
    el.buy = document.getElementById('c3buy');
    el.bar = document.getElementById('c3bar');
    el.lb = document.getElementById('c3lb');
    el.lb.onclick = function () { el.lb.classList.remove('on'); };
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') el.lb.classList.remove('on'); });
    document.getElementById('c3zoom').onclick = function (e) { e.stopPropagation(); openLB(shot('2400x2400', S.frame), samenvatting()); };
    readHash();
    upd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
